export default "__VITE_ASSET__Dsyey9Ap__"